import axios from "./axiosInstance";
import { PlanningConfigResponse, CertificateSettings, PlanificationSettings, AbsenceSettings, MessagingConfig } from "../types/instanceTypes";
import { ApiResponse } from "../types/apiTypes";

interface SignatureUploadResponse extends ApiResponse<{ url: string }> { }

// Fetch planning configuration for the current instance
export const getPlanningConfiguration = async (): Promise<PlanningConfigResponse> => {
  const response = await axios.get<PlanningConfigResponse>("/instance/planning-configuration");
  return response.data;
};

/**
 * Get certificate settings for the current instance
 */
export const getCertificateSettings = async (): Promise<CertificateSettings> => {
  const response = await axios.get<{ data: CertificateSettings }>('instance/certificate-config');
  return response.data.data;
};

/**
 * Update certificate settings for the current instance
 */
export const updateCertificateSettings = async (data: CertificateSettings): Promise<CertificateSettings> => {
  const response = await axios.put<{ data: CertificateSettings }>('instance/certificate-config', data);
  return response.data.data;
};

/**
 * Upload director signature image
 */
export const uploadDirectorSignature = async (file: File): Promise<string> => {
  try {
    const formData = new FormData();
    formData.append('signature', file);

    const response = await axios.post<SignatureUploadResponse>(
      '/instance/signature',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    if (!response.data || !response.data.data || !response.data.data.url) {
      throw new Error('Invalid response format from signature upload');
    }

    return response.data.data.url;
  } catch (error) {
    console.error('Error uploading signature:', error);
    throw error;
  }
};

export const updatePlanificationSettings = async (data: { planningConfiguration: PlanificationSettings }): Promise<PlanificationSettings> => {
  const response = await axios.put<{ data: PlanificationSettings }>('instance/planning-config', data);
  return response.data.data;
};



export const updateAbsenceSettings = async (data: { absenceConfig: AbsenceSettings }): Promise<AbsenceSettings> => {
  const response = await axios.put<{ data: AbsenceSettings }>('instance/absence-config', data);
  return response.data.data;
};

/**
 * Get certificate settings for the current instance
 */
export const getAbsenceSettings = async (): Promise<AbsenceSettings> => {
  const response = await axios.get<{ data: AbsenceSettings }>('instance/absence-config');
  return response.data.data;
};

export const updateLogo = async (imageFile: File | null): Promise<string> => {
  const formData = new FormData();
  if (imageFile) {
    formData.append("logo", imageFile);
  }

  const response = await axios.post<{ data: string }>("/instance/logo", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data.data;
};


export const getMessagingSettings = async (): Promise<MessagingConfig> => {
  const response = await axios.get<{ data: MessagingConfig }>(
    "instance/messaging-config"
  );
  return response.data.data;
};

export const updateMessagingSettings = async (data: {
  messagingConfig: MessagingConfig;
}): Promise<MessagingConfig> => {
  const response = await axios.put<{ data: MessagingConfig }>(
    "instance/messaging-config",
    data
  );
  return response.data.data;
};



